import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useJobProfilesByRegion = (regionId) => {
    const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
    return useQuery({
        queryKey: ['jobProfiles', regionId],
        queryFn: async () => {
            const result = await restClient({ url: `${prefix}/job-profiles/region/${regionId}` });
            return result;
        },
        enabled: !!regionId,
        staleTime: 5 * 60 * 1000
    });
};
